const state = {
  list: [
    {
      title: '氣ものよざはん',
      link: "https://www.kimono-yozahan.com/",
      img: 'projects/kimono-yozahan.jpg',
      dateStart: '2024-02-29',
      description: '氣ものよざはん',
      index: true,
      lang: ["Nuxt3", "NodeJs", "Firebase Hosting", "Firebase Functions", "MicroCMS", "SCSS", "I18nt"],
    },
    {
      title: '株式会社フルート',
      link: "https://flute-inc.co.jp/",
      img: 'projects/flute-inc.jpg',
      dateStart: '2022-04-01',
      description: '株式会社フルート正式ホームページ',
      index: false,
      lang: ["Nuxt", "NodeJs", "Firebase Hosting", "Firebase Cloud", "Firebase Functions"],
    },
    {
      title: 'おざわ歯科医院',
      link: null,
      img: 'projects/ozawa-dental-clinic.png',
      dateStart: '2020-10-10',
      description: 'おざわ歯科医院',
      index: false,
      lang: ["Nuxt", "Apollo", "Graphql", "HTML5", "CSS3", "NodeJs", "Express", "Eslint", "Firebase Hosting", "Firebase Cloud", "Firebase Functions"],
      projectEnded: true,
    },
    {
      title: 'Wistant',
      link: "https://www.wistant.com",
      img: 'projects/wistant.png',
      dateStart: '2019-04-15',
      dateEnd: "now",
      description: 'マネジメントの実行支援ツール',
      index: true,
      lang: ["React", "Apollo", "Graphql", "Styled-components", "NodeJs", "Express", "Typescript", "Eslint", "Husky", "..."],
    },
    {
      title: 'Tomomori Ozeki - Pianist',
      link: null,
      img: 'projects/tomonoriozaki.jpg',
      dateStart: '2016-02-16',
      projectEnded: true,
      description: 'ピアニストの紹介ホームページ',
      index: false,
      lang: ["VueJs", "Firebase Cloud", "Firebase Hosting"],
    },
    {
      title: 'Ta2mi',
      link: "https://web.archive.org/web/20180804234658/http://ta2mi.com/",
      img: 'projects/ta2mi.jpg',
      projectEnded: true,
      dateStart: '2018-03',
      description: 'Monk DJの紹介ホームページ',
      index: false
    },
    {
      title: 'Smartdojo',
      link: "https://www.smartdojo.net",
      img: 'projects/smartdojo.png',
      dateStart: '2018-10-01',
      dateEnd: "now",
      description: 'KarateTestから道場向けのサビースを作り直しております。',
      index: true,
      lang: ["Nuxt", "NodeJs", "Express", "GraphQl", "Apollo", "HTML5", "CSS3", "MongoDB", "Firebase Hosting", "Firebase Functions"],
    },
    {
      title: 'Macaso',
      link: null,
      img: 'projects/macaso.jpg',
      dateStart: '2018-01-15',
      dateEnd: '2018-05-31',
      description: '株式会社オハコで開発いたしましたFXのアプリ',
      lang: ["VueJs", "CSS3", "Html"],
      projectEnded: true,
    },
    {
      title: 'Idolmaster SideM',
      link: "https://side-m.idolmaster.jp/",
      img: 'projects/idolmaster.jpg',
      dateStart: '2014-06-01',
      dateEnd: '2018-01-14',
      description: 'バンダイナムコが製作する『THE IDOLM@STER』の世界観をモチーフとする携帯端末専用のソーシャルゲーム。',
      index: false,
      lang: ["HTML5", "CSS3", "jQuery", "createjs"],
    },
    {
      title: 'GUNDAM AREA WARS',
      link: "https://gaw.ggame.jp/",
      img: 'projects/gaw.jpg',
      dateStart: '2015-05-01',
      dateEnd: '2017-06-02',
      description: 'Webviewを利用しているIOS / Androidのガンダムのゲーム。',
      lang: ["HTML5", "CSS3", "jQuery"],
      projectEnded: true,
    },
    {
      title: 'Altplus Recruiting',
      link: null,
      img: 'projects/altplus.jpg',
      dateStart: '2017-08-02',
      dateEnd: '2017-08-09',
      description: '株式会社オルトプラスの<br />採用サイト',
      lang: ["javascript", "AngularJs v1", "NodeJS", "Yeoman2", "HTML5", "CSS3", "Bootstrap"],
      index: false,
      projectEnded: true,
    },
    {
      title: 'JLPT',
      link: null,
      img: 'projects/jlpt.jpg',
      dateStart: '2016-06-01',
      description: 'JLPT app for testing AngularJs: <br />Learn vocabulary in several languages',
      lang: ["javascript", "AngularJs v1", "NodeJS", "Yeoman2", "HTML5", "CSS3", "Bootstrap", "VPS Sakura"],
      projectEnded: true,
    },
    {
      title: 'KarateTest',
      link: null,
      img: 'projects/karatetest.jpg',
      dateStart: '2010-09-01',
      dateEnd: "2018-10-01",
      description: '卒論のために開発しましたプロジェクト。<br />オンラインで空手の技術を勉強するサイト',
      lang: ["CakePHP", "PHP", "SQL", "VPS Sakura", "Javascript", "jQuery", "HTML5", "CSS3", "SASS", "Photoshop"],
      projectEnded: true,
    },
  ]
};
const getters = {
  getProjects: state => {
    return state.list;
  }
};

export default {
  state,
  getters
};



// WEBPACK FOOTER //
// ./src/store/projects.js